const topics =
{
    helmet :
    {
        title : 'Sujets' ,
        metas : []
    }
};

export default topics ;